import React from 'react';
import classNames from 'classnames';
import { Button, ButtonGroup } from 'ui';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import { MODAL_TYPES } from './LessonGenerateModal';

const LessonGenerateActions = ({
  previous,
  next,
  isNextBtnDisabled = false,
  modal,
  displayWordCount,
  lessonText,
}) => {
  const WordCount = () => {
    const wordCount = lessonText
      ? lessonText
          .replace(/\n/gm, ' ')
          .split(' ')
          .filter(el => el !== '').length
      : 0;
    return (
      <Text variant={TEXT_VARIANTS.BODY_LIGHT} data-testid="actionsWordCount">
        {t('actions.lesson_generate_modal.word_count')} {wordCount}
      </Text>
    );
  };
  const PreviousBtn = () => {
    if (modal === MODAL_TYPES.FINISH) return false;
    return (
      <Button onClick={previous} data-testid="actionsPreviousButton">
        {t('actions.lesson_generate_modal.actions.back')}
      </Button>
    );
  };
  const NextButton = () => {
    let text;
    switch (modal) {
      case MODAL_TYPES.INITIAL_INFORMATION:
        text = t('actions.lesson_generate_modal.actions.lets_do_it');
        break;
      case MODAL_TYPES.FINISH:
        text = t('actions.lesson_generate_modal.actions.finish');
        break;
      default:
        text = t('actions.lesson_generate_modal.actions.next');
        break;
    }
    return (
      <Button
        customColor
        onClick={next}
        disabled={isNextBtnDisabled}
        data-testid="actionsNextButton"
      >
        {text}
      </Button>
    );
  };

  return (
    <div
      className={classNames('mt-16', {
        'd-f jc-sb': displayWordCount,
      })}
    >
      {displayWordCount && <WordCount />}
      <ButtonGroup alignEnd>
        <PreviousBtn />
        <NextButton />
      </ButtonGroup>
    </div>
  );
};

export default LessonGenerateActions;
